export const testimonialSections = [
    {
      title: (isMobile) => (
        <>
          To start {!isMobile && <br />} betting
        </>
      ),
      items: [
        "Explore the world of crypto betting with simple, intuitive tool",
        "Arcade mode",
        "Smooth onboarding",
        "Knowledge base",
        "Demo account with virtual money",
        "Internal wallet",
      ],
    },
    {
      title: (isMobile) => (
        <>
          To reach
          {!isMobile && <br />} new levels
        </>
      ),
      items: [
        "Use wide analytics abilities to predict market changes",
        "Wide range of assets to diversify portfolio",
        "Different crypto wallets can be used",
        "Contest activities to earn more",
        "High bet limits",
      ],
    },
    {
      title: (isMobile) => (
        <>
          To invest
          {!isMobile && <br />} into the project
        </>
      ),
      items: [
        "Technlogies used",
        "Strong experienced team",
        "Clear roadmap",
        "Large community",
      ],
    },
  ];